import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';
import { PERMISSIONS } from '@/constants/permissions';
import { useUserStore } from '@/stores/userStore';

/** 短剧库代码加载时按现有权限预留操作入口，并保留初始无分页布局 */
export function PlayletBankSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canCreate = permissionCodes?.includes(PERMISSIONS['短剧库管理/新增短剧库']);
  const canDelete = permissionCodes?.includes(PERMISSIONS['短剧库管理/删除短剧库']);

  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <ListPageSkeleton
        columnCount={8}
        showPagination={false}
        contentClassName="gap-4 p-6"
        filterArea={
          <div className="flex items-end justify-between gap-4 pb-4">
            <div className="flex-1">
              <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                <div className="flex flex-wrap gap-2 md:gap-4 md:items-center">
                  {/** 短剧搜索、重置和 TikTok 授权 */}
                  <div className="relative w-full md:w-auto">
                    <Skeleton className="h-9 w-full md:w-[250px]" />
                  </div>
                  <Skeleton className="h-9 w-16" />
                  <Skeleton className="h-9 w-28" />
                  {/** 新增与批量删除入口沿用页面权限 */}
                  {canCreate && <Skeleton className="h-9 w-28" />}
                  {canDelete && <Skeleton className="h-9 w-24" />}
                </div>
              </div>
            </div>
            {/** 列配置入口 */}
            <Skeleton className="h-9 w-24 shrink-0" />
          </div>
        }
      />
    </div>
  );
}
